'use strict';

module.exports = function (props, state) {
                    var selected = props.selected == null ? state.defaultSelected : props.selected;

                    return selected;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-datagrid/lib/getSelected.js
 ** module id = 931
 ** module chunks = 0
 **/